import React from "react";
import LoginContainer from "../components/login/LoginContainer";

const LoginMain = () => {
  return <LoginContainer />;
};
export default LoginMain;
